import axiosService from './axios-service';
import {ReportsDataRequest, WidgetDataRequest} from 'src/dtos/reports-data-request';
import {BlockedEventsResponse, HistogramDataResponse, NetworkActivityResponse} from 'src/dtos/reports-data-response';
import {
    AllReportsFieldsConfig
} from '@src/components/features/reports-and-logs/report-widget-factory/all-top10-columns-config';

class ReportService {
    public getReportsData = async (customerId: number, serviceId: number, body: ReportsDataRequest): Promise<AllReportsFieldsConfig[]> => {
        const result = await axiosService.post(`/api/insights/reports/customer/${customerId}/service/${serviceId}`, body, true);
        return result?.data;
    };

    public getHistogramReportData = async (customerId: number, serviceId: number, body: any): Promise<HistogramDataResponse> => {
        const result = await axiosService.post(`/api/insights/reports/customer/${customerId}/service/${serviceId}/histogram`, body, false);
        return result?.data;
    };

    public getBlockedEvent = async (customerId: number, serviceId: number, direction: string, from: number, to: number): Promise<BlockedEventsResponse> => {
        const path = `/api/insights/reports/customer/${customerId}/service/${serviceId}/dashboard-blocked-events`;
        const result = await axiosService.get(`${path}?direction=${direction}&from=${from}&to=${to}&execSummaryActive=true`);
        return result?.data;
    };

    public getNetworkActivity = async (customerId: number, serviceId: number, type: string, from: number, to: number): Promise<NetworkActivityResponse> => {
        const path = `/api/insights/reports/customer/${customerId}/service/${serviceId}`;
        const result = await axiosService.get(`${path}/network-activity/${type}?from=${from}&to=${to}`);
        return result?.data;
    };

    public getAvailableReports = async (customerId: number, serviceId: number) => {
        const path = `/api/insights/reports/customer/${customerId}/service/${serviceId}`;
        const result = await axiosService.get(`${path}?execSummaryActive=true`, true);
        return result?.data;
    };
    public getWidgetData = async (customerId: number, serviceId: number, body: WidgetDataRequest): Promise<any> => {
        const result = await axiosService.post(`/api/insights/reports/customer/${customerId}/service/${serviceId}/widget-data`, body, false);
        return result?.data;
    };
}

const reportService = new ReportService();
export default reportService;